'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    InputChip: ()=>InputChip
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_HorizonIcon_index_cjs_namespaceObject = require("../HorizonIcon/index.cjs");
const external_IconButton_index_cjs_namespaceObject = require("../IconButton/index.cjs");
const external_InputChip_variants_cjs_namespaceObject = require("./InputChip.variants.cjs");
function InputChip({ label, className, onCloseButtonClick, id, name, value, disabled, size = 'sm', iconLeft, customIcon, emphasis, ...props }) {
    const handleCloseButtonClick = ()=>{
        onCloseButtonClick?.();
    };
    const { labelTextSlot, containerSlot, iconLeftSlot, iconRightSlot, checkboxSlot } = (0, external_InputChip_variants_cjs_namespaceObject.inputChipVariants)({
        ...props,
        disabled,
        size,
        emphasis
    });
    const classes = (0, index_cjs_namespaceObject.cn)(containerSlot(), className);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        tabIndex: 0,
        role: "button",
        className: classes,
        ...(0, index_cjs_namespaceObject.cleanProps)(props, [
            'selected',
            'type',
            'elevated',
            'emphasis'
        ]),
        children: [
            iconLeft && !customIcon && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                className: iconLeftSlot(),
                iconName: iconLeft,
                size: '18'
            }),
            customIcon && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_HorizonIcon_index_cjs_namespaceObject.HorizonIcon, {
                className: iconLeftSlot(),
                name: customIcon,
                size: '18'
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: labelTextSlot(),
                children: label
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
                className: iconRightSlot(),
                onClick: handleCloseButtonClick,
                iconName: "close",
                size: "2xs",
                type: "plainSecondary",
                disabled: disabled,
                emphasis: emphasis
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("input", {
                className: checkboxSlot(),
                type: "checkbox",
                role: "checkbox",
                id: id,
                name: name,
                "data-testid": id,
                disabled: disabled,
                checked: true,
                readOnly: true,
                value: value,
                tabIndex: -1
            })
        ]
    });
}
exports.InputChip = __webpack_exports__.InputChip;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "InputChip"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
